module.exports = __webpack_public_path__ + "img/cq_timeline_12-d56900.png";